const state = {
  token: null,
  info: null,
  point: null,
  statistics: null,
  orderDetailVisible: false,
  currentOrderId: 0,
  currentOrderSn: undefined,
}

const mutations = {
  distributorPoint (state, payload) {
    state.point = payload.point
  },
  distributorLogin (state, payload) {
    state.token = payload.token
    state.info = payload.info
    state.info.client_type = "distributor"
    state.info.invalid_time = parseInt((new Date().getTime()) / 1000) + 3600// 一小时更新
    import('@/util/bugsnag').then(() => {
        console.log('bugsnag is loaded')
    }).catch((err) => {
        console.error(err)
    })
    this._vm.$socket.io.opts.extraHeaders.authorization = state.token
    this._vm.$socket.io.opts.extraHeaders.client_type = "distributor"
    this._vm.$socket.disconnect().connect()
    this._vm.$socket.emit('distributors:add', state.info, (response) => {
      console.log('Socket - Add Distributor', response)
    })
  },
  distributorUpdate (state, payload) {
    if (state.info) {
      state.info = payload.info
      state.info.invalid_time = parseInt((new Date().getTime()) / 1000) + 3600// 一小时更新
      this._vm.$socket.emit('distributors:update', payload.info, (response) => {
        console.log('Socket - Update Distributor', response)
      })
    }
  },
  distributorEdit (state, payload) {
    if (state.info) {
      let i
      for (i in payload) {
        state.info[i] = payload[i]
      }
      this._vm.$socket.emit('distributors:update', state.info, (response) => {
        console.log('Socket - Update Distributor', response)
      })
    }
  },
  distributorStatistics (state, payload) {
    state.statistics = payload.statistics
    state.statistics.invalid_time = parseInt((new Date(new Date().toLocaleDateString()).getTime()) / 1000) + 86399// 今日内有效
  },
  distributorLogout (state) {
    this._vm.$socket.emit('distributors:delete', 'wap', (response) => {
      console.log('Socket - Remove Distributor', response)
    })
    this._vm.$socket.disconnect()
    state.token = null
    state.info = null
    state.statistics = null
  },
  distributorOrderDetail (state, payload) {
    state.orderDetailVisible = payload
  },
  distributorCurrentOrderId (state, payload) {
    state.currentOrderId = payload
  },
  distributorCurrentOrderSn (state, payload) {
    state.currentOrderSn = payload
  }
}


const getters = {    
  distributorInfo(state, getters) {		
		return state.info;
	},
}


export default {
  state,
  mutations,
  getters
}
